const HR_BODY = `<div id="header">
  <div id="header-inner">
    <div class="brand">
      <div class="logo-box">HH</div>
      <div><div class="brand-name">FIELD SMART</div><div class="brand-sub">HR &amp; Payroll Management System</div></div>
    </div>
    <div style="display:flex;align-items:center;gap:12px;">
    <div id="hdr-context" style="font-size:11px;opacity:0.75;background:rgba(255,255,255,0.1);padding:3px 10px;border-radius:12px;">May 2026</div>
    <div style="font-size:11px;opacity:0.6;" id="hdr-date">Thursday, 28 May 2026</div>
  </div>
  </div>
  <div class="tabs">
    <button class="tab" onclick="setTab(&#39;dashboard&#39;)"><i class="ti ti-home"></i> Dashboard</button>
    <button class="tab" onclick="setTab(&#39;employees&#39;)"><i class="ti ti-users"></i> Employees</button>
    <button class="tab" onclick="setTab(&#39;attendance&#39;)"><i class="ti ti-calendar"></i> Attendance</button>
    <button class="tab" onclick="setTab(&#39;salary&#39;)"><i class="ti ti-receipt"></i> Salary</button>
    <button class="tab" onclick="setTab(&#39;slip&#39;)"><i class="ti ti-file-text"></i> Pay Slips</button>
    <button class="tab" onclick="setTab(&#39;kpi&#39;)"><i class="ti ti-target"></i> KPI Tracker</button>
    <button class="tab" onclick="setTab(&#39;pip&#39;)"><i class="ti ti-alert-triangle"></i> PIP</button>
  </div>
</div>

<div id="content">
  <div id="dashboard" class="page">
    <div class="page-hdr"><h2>Payroll overview</h2><div class="mnav">
    <button class="btn btn-sm" onclick="prevMonth()"><i class="ti ti-chevron-left"></i></button>
    <span class="mnav-label">May 2026</span>
    <button class="btn btn-sm" onclick="nextMonth()"><i class="ti ti-chevron-right"></i></button>
  </div></div>
    <div class="g4 mb">
      <div class="stat"><div class="stat-lbl">Total employees</div><div class="stat-val">3</div><div class="stat-sub">Active on payroll</div></div>
      <div class="stat"><div class="stat-lbl">Total gross payable</div><div class="stat-val">₹41,192</div><div class="stat-sub">May 2026</div></div>
      <div class="stat"><div class="stat-lbl">Total net pay</div><div class="stat-val">₹40,992</div><div class="stat-sub">Take-home sum</div></div>
      <div class="stat"><div class="stat-lbl">Total store visits</div><div class="stat-val" style="color:var(--orange);">8</div><div class="stat-sub">All employees this month</div></div>
    </div>
    <div class="card">
      <div class="card-head"><h3>Employee summary — May 2026</h3></div>
      <table>
        <thead><tr><th>Employee</th><th>Grade</th><th>Gross Pay</th><th>LOP Deduction</th><th>PF</th><th>Net Pay</th><th>Total Visits</th></tr></thead>
        <tbody><tr class="row-stripe">
      <td><div style="font-weight:600;">Rajesh Jain</div><div class="text-sub fs">Sr. Sales Executive · Gujarat</div></td>
      <td><span class="badge bg-jm2">JM2</span></td>
      <td style="font-weight:600;">₹41,192</td>
      <td style="color:#bbb;">—</td>
      <td class="text-sub">₹0</td>
      <td style="font-weight:700;color:var(--navy);">₹40,992</td>
      <td><div style="font-weight:600;color:var(--orange);">8</div><div style="font-size:10px;color:var(--subtext);">target: 312</div></td>
    </tr><tr class="row-stripe">
      <td><div style="font-weight:600;">Vijay Kathad</div><div class="text-sub fs">Sales Executive · Saurashtra</div></td>
      <td><span class="badge bg-jm1">JM1</span></td>
      <td style="font-weight:600;">₹0</td>
      <td style="color:var(--red);">-₹22,557</td>
      <td class="text-sub">₹0</td>
      <td style="font-weight:700;color:var(--navy);">₹0</td>
      <td><div style="font-weight:600;color:var(--orange);">0</div><div style="font-size:10px;color:var(--subtext);">target: 0</div></td>
    </tr><tr class="row-stripe">
      <td><div style="font-weight:600;">Sumer Singh</div><div class="text-sub fs">Area Sales Manager · Rajasthan</div></td>
      <td><span class="badge bg-jm3">JM3</span></td>
      <td style="font-weight:600;">₹0</td>
      <td style="color:var(--red);">-₹49,038</td>
      <td class="text-sub">₹0</td>
      <td style="font-weight:700;color:var(--navy);">₹0</td>
      <td><div style="font-weight:600;color:var(--orange);">0</div><div style="font-size:10px;color:var(--subtext);">target: 0</div></td>
    </tr></tbody>
        <tfoot><tr style="background:var(--navy);color:#fff;">
          <td colspan="2" style="padding:8px 12px;font-weight:700;">TOTAL</td>
          <td style="padding:8px 12px;font-weight:700;">₹41,192</td>
          <td></td><td></td>
          <td style="padding:8px 12px;font-weight:700;">₹40,992</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--orange);">8 visits</td>
        </tr></tfoot>
      </table>
    </div></div>
  <div id="employees" class="page"></div>
  <div id="attendance" class="page"></div>
  <div id="salary" class="page"></div>
  <div id="slip-page" class="page"></div>
  <div id="kpi" class="page active">
    <div class="page-hdr">
      <h2>KPI Tracker — May 2026</h2>
      <div style="display:flex;gap:8px;"><div class="mnav">
    <button class="btn btn-sm" onclick="prevMonth()"><i class="ti ti-chevron-left"></i></button>
    <span class="mnav-label">May 2026</span>
    <button class="btn btn-sm" onclick="nextMonth()"><i class="ti ti-chevron-right"></i></button>
  </div></div>
    </div>
    <div class="filter-chips">
    <button class="chip active" onclick="setKPIFilter(null)">👥 All Employees</button>
    <button class="chip" onclick="setKPIFilter(&#39;EMP001&#39;)">Rajesh</button><button class="chip" onclick="setKPIFilter(&#39;EMP002&#39;)">Vijay</button><button class="chip" onclick="setKPIFilter(&#39;EMP003&#39;)">Sumer</button>
  </div>
    <div style="background:var(--lamber);border-radius:8px;padding:8px 14px;margin-bottom:14px;font-size:11px;color:var(--amber);display:flex;gap:6px;align-items:center;">
      <i class="ti ti-info-circle"></i>
      <span><b>Weightage:</b> Billed Revenue 50% · Store Visits 25% (auto from attendance) · New Stores 15% · Collection 10%  &nbsp;|&nbsp; <b>Rating triggers:</b> &gt;130% Exceptional · 110–130% Exceeds · 90–110% Meets · 70–90% Needs Improvement · &lt;70% Unsatisfactory → Auto PIP</span>
    </div>
    <div class="kpi-card">
      <div class="kpi-head">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;">RJ</div>
          <div>
            <div style="font-weight:700;font-size:14px;">Rajesh Jain </div>
            <div style="font-size:11px;opacity:0.65;">Sr. Sales Executive · Gujarat · CTC ₹42,000</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:12px;">
          <div style="text-align:center;">
            <div class="pct-ring" style="color:#991b1b;border-color:#991b1b;">10%</div>
            <div style="font-size:9px;color:rgba(255,255,255,0.7);margin-top:2px;">Overall</div>
          </div>
          <div>
            <div class="rating-pill r5">Unsatisfactory</div>
            <div style="font-size:10px;opacity:0.7;margin-top:3px;">Increment: Nil · Bonus: Statutory only</div>
          </div>
        </div>
      </div>
      <div class="kpi-body"><div class="kpi-metric">
      <div class="kpi-metric-lbl">💰 Billed Revenue</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: ₹3,00,000</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 50% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:120px;" placeholder="₹ Achieved" value="" onchange="updateKPIField(&#39;EMP001&#39;,&#39;billedRev&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏪 Store Visits</div>
      <div class="kpi-metric-val">8 visits</div>
      <div class="kpi-metric-target">Target: 312</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:3%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">3% achieved · 25% weight (auto)</div>
      <div style="margin-top:6px;"><div style="font-size:11px;color:var(--subtext);">Auto-pulled from attendance</div></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">➕ New Stores Added</div>
      <div class="kpi-metric-val">0 stores</div>
      <div class="kpi-metric-target">Target: 5</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 15% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:80px;" placeholder="Count" value="" onchange="updateKPIField(&#39;EMP001&#39;,&#39;newStores&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏦 Collection (₹)</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: Set target</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 10% weight</div>
      <div style="margin-top:6px;"><div style="display:flex;gap:4px;"><input type="number" class="input-sm" style="width:110px;" placeholder="₹ Collected" value="" onchange="updateKPIField(&#39;EMP001&#39;,&#39;collection&#39;,this.value);renderKPI();">
               <input type="number" class="input-sm" style="width:110px;" placeholder="₹ Target" value="" onchange="updateKPIField(&#39;EMP001&#39;,&#39;collectionTarget&#39;,this.value);renderKPI();"></div></div>
    </div></div>
      <div style="padding:10px 14px;background:var(--gray);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
        <div style="display:flex;gap:8px;align-items:center;">
          <span style="font-size:11px;color:var(--subtext);">Revenue target:</span>
          <input type="number" class="input-sm" style="width:120px;" placeholder="₹ Monthly target" value="300000" onchange="updateKPIField(&#39;EMP001&#39;,&#39;revTarget&#39;,this.value);renderKPI();">
          <span style="font-size:11px;color:var(--subtext);">New store target:</span>
          <input type="number" class="input-sm" style="width:70px;" placeholder="Stores" value="5" onchange="updateKPIField(&#39;EMP001&#39;,&#39;newStoresTarget&#39;,this.value);renderKPI();">
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          
          <button class="btn btn-sm" style="background:#fee2e2;border-color:#fca5a5;color:#991b1b;" onclick="setTab(&#39;pip&#39;);document.getElementById(&#39;pip-form-emp&#39;).value=&#39;EMP001&#39;;document.getElementById(&#39;pip-modal&#39;).style.display=&#39;flex&#39;;">⚠️ Initiate PIP</button>
          <button class="btn btn-sm" onclick="addKPINotes(&#39;EMP001&#39;)">📝 Notes</button>
        </div>
      </div>
      
    </div><div class="kpi-card">
      <div class="kpi-head">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;">VK</div>
          <div>
            <div style="font-weight:700;font-size:14px;">Vijay Kathad </div>
            <div style="font-size:11px;opacity:0.65;">Sales Executive · Saurashtra · CTC ₹23,000</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:12px;">
          <div style="text-align:center;">
            <div class="pct-ring" style="color:#991b1b;border-color:#991b1b;">35%</div>
            <div style="font-size:9px;color:rgba(255,255,255,0.7);margin-top:2px;">Overall</div>
          </div>
          <div>
            <div class="rating-pill r5">Unsatisfactory</div>
            <div style="font-size:10px;opacity:0.7;margin-top:3px;">Increment: Nil · Bonus: Statutory only</div>
          </div>
        </div>
      </div>
      <div class="kpi-body"><div class="kpi-metric">
      <div class="kpi-metric-lbl">💰 Billed Revenue</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: ₹3,00,000</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 50% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:120px;" placeholder="₹ Achieved" value="" onchange="updateKPIField(&#39;EMP002&#39;,&#39;billedRev&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏪 Store Visits</div>
      <div class="kpi-metric-val">0 visits</div>
      <div class="kpi-metric-target">Target: 0</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 25% weight (auto)</div>
      <div style="margin-top:6px;"><div style="font-size:11px;color:var(--subtext);">Auto-pulled from attendance</div></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">➕ New Stores Added</div>
      <div class="kpi-metric-val">0 stores</div>
      <div class="kpi-metric-target">Target: 5</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 15% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:80px;" placeholder="Count" value="" onchange="updateKPIField(&#39;EMP002&#39;,&#39;newStores&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏦 Collection (₹)</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: Set target</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 10% weight</div>
      <div style="margin-top:6px;"><div style="display:flex;gap:4px;"><input type="number" class="input-sm" style="width:110px;" placeholder="₹ Collected" value="" onchange="updateKPIField(&#39;EMP002&#39;,&#39;collection&#39;,this.value);renderKPI();">
               <input type="number" class="input-sm" style="width:110px;" placeholder="₹ Target" value="" onchange="updateKPIField(&#39;EMP002&#39;,&#39;collectionTarget&#39;,this.value);renderKPI();"></div></div>
    </div></div>
      <div style="padding:10px 14px;background:var(--gray);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
        <div style="display:flex;gap:8px;align-items:center;">
          <span style="font-size:11px;color:var(--subtext);">Revenue target:</span>
          <input type="number" class="input-sm" style="width:120px;" placeholder="₹ Monthly target" value="300000" onchange="updateKPIField(&#39;EMP002&#39;,&#39;revTarget&#39;,this.value);renderKPI();">
          <span style="font-size:11px;color:var(--subtext);">New store target:</span>
          <input type="number" class="input-sm" style="width:70px;" placeholder="Stores" value="5" onchange="updateKPIField(&#39;EMP002&#39;,&#39;newStoresTarget&#39;,this.value);renderKPI();">
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          
          <button class="btn btn-sm" style="background:#fee2e2;border-color:#fca5a5;color:#991b1b;" onclick="setTab(&#39;pip&#39;);document.getElementById(&#39;pip-form-emp&#39;).value=&#39;EMP002&#39;;document.getElementById(&#39;pip-modal&#39;).style.display=&#39;flex&#39;;">⚠️ Initiate PIP</button>
          <button class="btn btn-sm" onclick="addKPINotes(&#39;EMP002&#39;)">📝 Notes</button>
        </div>
      </div>
      
    </div><div class="kpi-card">
      <div class="kpi-head">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;">SS</div>
          <div>
            <div style="font-weight:700;font-size:14px;">Sumer Singh </div>
            <div style="font-size:11px;opacity:0.65;">Area Sales Manager · Rajasthan · CTC ₹50,000</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:12px;">
          <div style="text-align:center;">
            <div class="pct-ring" style="color:#991b1b;border-color:#991b1b;">35%</div>
            <div style="font-size:9px;color:rgba(255,255,255,0.7);margin-top:2px;">Overall</div>
          </div>
          <div>
            <div class="rating-pill r5">Unsatisfactory</div>
            <div style="font-size:10px;opacity:0.7;margin-top:3px;">Increment: Nil · Bonus: Statutory only</div>
          </div>
        </div>
      </div>
      <div class="kpi-body"><div class="kpi-metric">
      <div class="kpi-metric-lbl">💰 Billed Revenue</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: ₹3,00,000</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 50% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:120px;" placeholder="₹ Achieved" value="" onchange="updateKPIField(&#39;EMP003&#39;,&#39;billedRev&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏪 Store Visits</div>
      <div class="kpi-metric-val">0 visits</div>
      <div class="kpi-metric-target">Target: 0</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 25% weight (auto)</div>
      <div style="margin-top:6px;"><div style="font-size:11px;color:var(--subtext);">Auto-pulled from attendance</div></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">➕ New Stores Added</div>
      <div class="kpi-metric-val">0 stores</div>
      <div class="kpi-metric-target">Target: 5</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 15% weight</div>
      <div style="margin-top:6px;"><input type="number" class="input-sm" style="width:80px;" placeholder="Count" value="" onchange="updateKPIField(&#39;EMP003&#39;,&#39;newStores&#39;,this.value);renderKPI();"></div>
    </div><div class="kpi-metric">
      <div class="kpi-metric-lbl">🏦 Collection (₹)</div>
      <div class="kpi-metric-val">₹0</div>
      <div class="kpi-metric-target">Target: Set target</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:0%;background:#C0392B;"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">0% achieved · 10% weight</div>
      <div style="margin-top:6px;"><div style="display:flex;gap:4px;"><input type="number" class="input-sm" style="width:110px;" placeholder="₹ Collected" value="" onchange="updateKPIField(&#39;EMP003&#39;,&#39;collection&#39;,this.value);renderKPI();">
               <input type="number" class="input-sm" style="width:110px;" placeholder="₹ Target" value="" onchange="updateKPIField(&#39;EMP003&#39;,&#39;collectionTarget&#39;,this.value);renderKPI();"></div></div>
    </div></div>
      <div style="padding:10px 14px;background:var(--gray);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
        <div style="display:flex;gap:8px;align-items:center;">
          <span style="font-size:11px;color:var(--subtext);">Revenue target:</span>
          <input type="number" class="input-sm" style="width:120px;" placeholder="₹ Monthly target" value="300000" onchange="updateKPIField(&#39;EMP003&#39;,&#39;revTarget&#39;,this.value);renderKPI();">
          <span style="font-size:11px;color:var(--subtext);">New store target:</span>
          <input type="number" class="input-sm" style="width:70px;" placeholder="Stores" value="5" onchange="updateKPIField(&#39;EMP003&#39;,&#39;newStoresTarget&#39;,this.value);renderKPI();">
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          
          <button class="btn btn-sm" style="background:#fee2e2;border-color:#fca5a5;color:#991b1b;" onclick="setTab(&#39;pip&#39;);document.getElementById(&#39;pip-form-emp&#39;).value=&#39;EMP003&#39;;document.getElementById(&#39;pip-modal&#39;).style.display=&#39;flex&#39;;">⚠️ Initiate PIP</button>
          <button class="btn btn-sm" onclick="addKPINotes(&#39;EMP003&#39;)">📝 Notes</button>
        </div>
      </div>
      
    </div>
    <div class="card">
      <div class="card-head"><h3>📊 Annual Performance Summary — 2026</h3></div>
      <div style="overflow-x:auto;">
        <table class="ann-table" style="width:100%;border-collapse:collapse;">
          <thead><tr style="background:var(--gray);">
            <th>Employee</th>
            <th style="text-align:center;width:48px;">Jan</th><th style="text-align:center;width:48px;">Feb</th><th style="text-align:center;width:48px;">Mar</th><th style="text-align:center;width:48px;">Apr</th><th style="text-align:center;width:48px;">May</th><th style="text-align:center;width:48px;">Jun</th><th style="text-align:center;width:48px;">Jul</th><th style="text-align:center;width:48px;">Aug</th><th style="text-align:center;width:48px;">Sep</th><th style="text-align:center;width:48px;">Oct</th><th style="text-align:center;width:48px;">Nov</th><th style="text-align:center;width:48px;">Dec</th>
            <th style="text-align:center;">Annual Avg</th>
            <th style="text-align:center;">Increment</th>
            <th style="text-align:center;">Diwali Bonus</th>
          </tr></thead>
          <tbody><tr>
      <td style="font-weight:600;">Rajesh Jain</td>
      <td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
    </tr><tr>
      <td style="font-weight:600;">Vijay Kathad</td>
      <td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
    </tr><tr>
      <td style="font-weight:600;">Sumer Singh</td>
      <td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td><td style="text-align:center;color:#ccc;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
      <td style="text-align:center;">—</td>
    </tr></tbody>
        </table>
      </div>
    </div></div>
  <div id="pip" class="page"></div>
</div>

<!-- Employee Modal -->
<div id="emp-modal" class="modal-bg" style="display:none;" onclick="if(event.target===this)closeModal()">
  <div class="modal">
    <div class="modal-head"><h3 id="modal-title">Add Employee</h3>
      <button class="btn btn-sm" style="color:#fff;border-color:rgba(255,255,255,0.3);" onclick="closeModal()"><i class="ti ti-x"></i></button>
    </div>
    <div class="modal-body">
      <!-- Basic Info -->
      <div class="form-section-title"><i class="ti ti-user" style="font-size:12px;"></i> Basic Information</div>
      <div class="form-row">
        <div class="form-group"><label>Full Name *</label><input id="f-name" placeholder="Employee full name"></div>
        <div class="form-group"><label>Phone</label><input id="f-phone" type="tel" placeholder="10-digit mobile"></div>
      </div>
      <div class="form-row">
        <div class="form-group"><label>Grade</label>
          <select id="f-grade" onchange="gradeChanged()">
            <option value="JM1">JM1 — Sales Executive</option>
            <option value="JM2">JM2 — Sr. Sales Executive</option>
            <option value="JM3">JM3 — Area Sales Manager</option>
            <option value="JM4">JM4 — Regional Sales Manager</option>
            <option value="JM5">JM5 — National Sales Manager</option>
            <option value="SM">SM — Senior Management</option>
          </select>
        </div>
        <div class="form-group"><label>Territory</label><input id="f-territory" placeholder="e.g. Gujarat, Rajasthan"></div>
      </div>
      <div class="form-row">
        <div class="form-group"><label>Date of Joining</label><input id="f-doj" type="date"></div>
        <div class="form-group"><label>Email</label><input id="f-email" type="email" placeholder="employee@email.com"></div>
      </div>
      <!-- Salary Structure -->
      <div class="form-section-title" style="margin-top:8px;"><i class="ti ti-wallet" style="font-size:12px;"></i> Salary Structure</div>
      <div class="form-row">
        <div class="form-group"><label>Monthly CTC (₹) *</label><input id="f-ctc" type="number" placeholder="e.g. 30000" oninput="previewSalary()"></div>
        <div class="form-group"><label>Daily Visit Target</label>
          <input id="f-visit-target" type="number" min="1" max="50" placeholder="e.g. 12" style="">
          <div style="font-size:10px;color:var(--subtext);margin-top:3px;">Store visits per working day (for reporting)</div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Travel Allowance (₹/month) <span class="info-tag">Editable</span></label>
          <input id="f-ta" type="number" placeholder="Default: 1600" oninput="previewSalary()">
          <div style="font-size:10px;color:var(--subtext);margin-top:3px;">Leave blank to use default ₹1,600</div>
        </div>
        <div class="form-group">
          <label>Special Allowance (₹/month) <span class="info-tag">Editable</span></label>
          <input id="f-special" type="number" placeholder="Auto-calculated if blank" oninput="previewSalary()">
          <div style="font-size:10px;color:var(--subtext);margin-top:3px;">Leave blank to auto-calculate as balance</div>
        </div>
        <div class="form-group">
          <label>Mobile Allowance (₹/month) <span class="info-tag">Editable</span></label>
          <input id="f-mobile" type="number" placeholder="Default: 399" oninput="previewSalary()">
          <div style="font-size:10px;color:var(--subtext);margin-top:3px;">HR policy: ₹399/month (editable per employee)</div>
        </div>
      </div>
      <!-- PF & ESIC Section -->
      <div class="form-section-title" style="margin-top:8px;"><i class="ti ti-shield" style="font-size:12px;"></i> Statutory Deductions — PF &amp; ESIC</div>
      <div style="background:var(--lamber);border-radius:7px;padding:8px 12px;margin-bottom:10px;font-size:11px;color:var(--amber);">
        <i class="ti ti-info-circle" style="font-size:11px;"></i> <b>Company status:</b> Leave PF Rate blank (0) if company is not yet registered / not liable for PF. ESIC is off by default. Fields can be enabled per employee when required.
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>PF Rate (%) — Employee &amp; Employer each</label>
          <input id="f-pfrate" type="number" min="0" max="100" step="0.01" placeholder="Leave blank = Not applicable" oninput="previewSalary()">
          <div style="font-size:10px;color:var(--subtext);margin-top:3px;">
            📌 <b>Standard statutory rate: 12%</b> of Basic Salary | Employer + Employee each contribute 12% | Employer share capped at ₹1,800/month (on wage ceiling ₹15,000)
          </div>
        </div>
        <div class="form-group">
          <label>ESIC Applicable?</label>
          <div style="display:flex;align-items:center;gap:10px;margin-top:4px;">
            <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:13px;font-weight:400;">
              <input type="checkbox" id="f-esic" onchange="previewSalary()" style="width:16px;height:16px;cursor:pointer;"> Enable ESIC for this employee
            </label>
          </div>
          <div style="font-size:10px;color:var(--subtext);margin-top:5px;">
            📌 <b>Standard: Employee 0.75% + Employer 3.25%</b> of Gross Salary | Only applicable if Gross ≤ ₹21,000/month | Provides medical insurance cover
          </div>
        </div>
      <div style="display:none;">
      </div>
      <!-- Salary Preview -->
      <div id="salary-preview" style="display:none;background:var(--lnavy);border-radius:8px;padding:12px;margin-bottom:10px;">
        <div style="font-size:11px;font-weight:700;color:var(--navy);margin-bottom:8px;"><i class="ti ti-calculator" style="font-size:11px;"></i> Salary Preview</div>
        <div id="preview-content" style="display:grid;grid-template-columns:repeat(4,1fr);gap:6px;font-size:11px;"></div>
      </div>
      <!-- Statutory -->
      <div class="form-section-title" style="margin-top:8px;"><i class="ti ti-building-bank" style="font-size:12px;"></i> Bank &amp; Statutory Details</div>
      <div class="form-row">
        <div class="form-group"><label>PAN Number</label><input id="f-pan" placeholder="ABCDE1234F"></div>
        <div class="form-group"><label>UAN (EPFO)</label><input id="f-uan" placeholder="12-digit UAN"></div>
      </div>
      <div class="form-row">
        <div class="form-group"><label>Bank Name</label><input id="f-bank" placeholder="e.g. HDFC Bank"></div>
        <div class="form-group"><label>Account Number</label><input id="f-account" placeholder="Bank account number"></div>
      </div>
      <div class="form-row">
        <div class="form-group"><label>IFSC Code</label><input id="f-ifsc" placeholder="HDFC0001234"></div>
      </div>
    </div>
    </div>
      <div class="modal-foot">
      <button class="btn" onclick="closeModal()">Cancel</button>
      <button class="btn btn-primary" onclick="saveEmployee()"><i class="ti ti-check"></i> Save Employee</button>
    </div>
  </div>
</div>
`;
export default HR_BODY;
